import Vue from 'vue'
import {MutationTree} from 'vuex'
import {RootState} from '@/store/types'


export interface State {
  show: boolean,
  messages: string[],
  contentClass: string,
  color: string,
  textColor: string,
  fontSize: string,
  time?:number,
  position: {
    left?: boolean,
    right?: boolean,
    top?: boolean,
    bottom?: boolean,
    centered?: boolean,
  }
}

const defaultState: State = {
  show: false,
  messages: [],
  contentClass: '',
  color: '#494949',
  textColor: '#fff',
  fontSize: '16px',
  time: 4000,
  position: {}
};

const getters = {
  time: (state: State) => state.time,
  show: (state: State) => state.show,
  messages: (state: State) => state.messages,
  position: (state: State) => state.position,
  contentClass: (state: State) => state.contentClass,
  color: (state: State) => state.color,
  textColor: (state: State) => state.textColor,
  fontSize: (state: State) => state.fontSize
}

const mutations: MutationTree<State> = {
  setAlert(state:State,payload:State){
    state.show = payload.show
    state.messages = payload.messages
    if(payload.time) state.time = payload.time
    if (payload.position) state.position = payload.position
    if (payload.contentClass) state.contentClass = payload.contentClass
    if (payload.color) state.color = payload.color
    if (payload.textColor) state.textColor = payload.textColor
    if (payload.fontSize) state.fontSize = payload.fontSize

    setTimeout(()=>{
      state.show = false
      state.messages =[]
    },state.time)
  },
  setShow(state: State, payload: boolean) {
    state.show = payload
  },
  setMassages(state: State, payload: string) {
    state.messages.push(payload)
  },
  clear(state:State){
    state.show =false
    state.messages =[]
    state.position = {}
    state.color = ''
    state.textColor = ''
    state.fontSize = ''
    state.contentClass = ''
  }
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations
}
